
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_60808_5495)","stroke":"#4A4A4A","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M8 8L4.2 5.15a.5.5 0 01-.2-.4V2.5a.5.5 0 01.5-.5h7a.5.5 0 01.5.5v2.228a.5.5 0 01-.199.397L8 8zM8 8l-3.8 2.85a.5.5 0 00-.2.4v2.25a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-2.227a.5.5 0 00-.199-.4L8 8zM4 4h8"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_60808_5495"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    